import { ProductOptionsApi } from "../../apis/ProductOptionsApi";
import { CustomDialog } from "../../components/dialog/v1/CustomDialog";
import styled from 'styled-components';
import { useApiInfoContextValueHook } from "../../contexts/ApiInfoContext";
import { SellertoolSignatureUtils } from "../../utils/sellertool-signature-utils";
import { useEffect, useRef, useState } from "react";
import { CustomBackdropController } from "../../components/backdrop/default/v1";
import CustomBlockButton from "../../components/button/CustomBlockButton";
import { CustomRatioImage } from "../../components/image/CustomRatioImage";
import { DialogContent } from "@mui/material";
import CustomSelect from "../../components/select/default/v1/CustomSelect";
import CutstomRefInput from "../../components/input/CustomInput";

const StyledHeader = styled.div`
    padding:10px;
`;

const StyledBody = styled.div`
    padding:10px;
`;

const StyledSearchCondition = styled.div`
    display: flex;
    gap: 10px;
    margin-bottom: 20px;
    align-items: center;
    select{
        width: 150px;
        border-radius: 3px;
    }

    input{
        width: 100%;
        border-radius: 3px;
        flex:1;
        border-color: #e0e0e0;
    }

    & button{
        width: 48px;
        height: 48px;
        border-radius: 3px;

        .icon-figure{
            width: 50%;
            height: 50%;
        }

        &.disabled{
            opacity: 0.2;
        }
    }
`;

const StyledCardList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

const StyledCard = styled.div`
    border: 1px solid #efefef;
    padding: 10px;
    border-radius:3px;
    display: flex;
    flex-direction: column;
    gap: 5px;
    cursor: pointer;

    &:hover{
        background: #f9f9f9;
    }

    .name-wrapper{
        display: flex;
        gap: 5px;
        font-size: 14px;
        font-weight: 500;
        align-items: center;

        & .package{
            font-size: 10px;
            border-radius: 3px;
            background: var(--greenColor1-light);
            color: var(--greenColor1);
            padding: 3px 5px;
            display: inline-block;
        }
    }

    .optionCode-wrapper{
        font-size: 10px;
        font-weight: 500;
        color: #666;
    }

    .stock-wrapper{
        font-size: 10px;
        font-weight: 500;
        color: #333;

        &.out-of-stock{
            color: var(--redColor1);
        }
    }
`;

const StyledPagination = styled.div`
    margin-top: 10px;
    display: flex;
    justify-content: center;
    gap: 20px;
    align-items: center;

    & .page-number{
        font-size: 12px;
        font-weight: 600;
    }

    & button{
        width: 30px;
        height: 30px;
        border-radius: 50%;
        border: none;

        .icon-figure{
            width: 80%;
            height: 80%;
        }

        &.disabled{
            opacity: 0.2;
        }
    }
`;

export function GlobalWegetProductOptionModal({
    open,
    onClose = () => { },
    onSelectItem = () => { }
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();

    const scrollRef = useRef();
    const searchConditionRef = useRef();
    const searchQueryRef = useRef();

    const [productOptionsStructure, setProductOptionsStructure] = useState();
    const [page, setPage] = useState(1);
    const [searchCondition, setSearchCondition] = useState('PRODUCT_NAME_AND_OPTION_NAME');
    const [searchQuery, setSearchQuery] = useState('');

    useEffect(() => {
        if (!apiInfoContextValueHook?.apiInfo?.apiKey || !apiInfoContextValueHook?.apiInfo?.secretKey) {
            return;
        }
        handleReqFetchProductOptions();
    }, [apiInfoContextValueHook?.apiInfo?.apiKey, apiInfoContextValueHook?.apiInfo?.secretKey, page, searchQuery, searchCondition]);

    const handleReqFetchProductOptions = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        let params = {
            page: page,
            ignoreSpaceYn: 'y'
        }

        if (searchQuery) {
            if (searchCondition === 'PRODUCT_NAME_AND_OPTION_NAME') {
                const searchQuerySplit = searchQuery?.split('&&');
                params.productName = searchQuerySplit[0];
                if (searchQuerySplit?.length > 1) {
                    params.productOptionName = searchQuerySplit[1];
                }
            } else if (searchCondition === 'PRODUCT_OPTION_CODE') {
                params.productOptionCode = searchQuery;
            }
        }

        CustomBackdropController().showBackdrop();
        const response = await ProductOptionsApi().searchListDetail({
            headers: headers, params: params
        });

        if (response?.content) {
            setProductOptionsStructure(response?.content);
        }

        CustomBackdropController().hideBackdrop();

    }

    const handlePageToPrev = () => {
        if (page <= 1) {
            return;
        }

        setPage(prev => prev - 1);

        // 스크롤 최상단으로 이동
        if (scrollRef.current) {
            scrollRef.current.scrollTop = 0;
        }
    }

    const handlePageToNext = () => {
        if (!productOptionsStructure?.hasNext) {
            return;
        }

        setPage(prev => prev + 1);

        // 스크롤 최상단으로 이동
        if (scrollRef.current) {
            scrollRef.current.scrollTop = 0;
        }
    }

    const handleSetSearchQuery = () => {
        setSearchCondition(searchConditionRef.current.value);
        setSearchQuery(searchQueryRef.current.value);
        setPage(1);
    }

    const handleRefreshSearchCondition = () => {
        setSearchQuery('');
        searchQueryRef.current.value = '';
        setPage(1);
    }

    const handleClickCard = (item) => {
        onSelectItem(item);
        onClose();
    }

    return (
        <>
            <CustomDialog
                open={open}
                onClose={onClose}
                maxWidth="sm"
                PaperProps={{
                    ref: scrollRef, // 여기서 ref를 전달
                }}
            >
                <StyledHeader>
                    <CustomDialog.Header>
                        <CustomDialog.Header.Fake />
                        <CustomDialog.Header.Title>상품정보 조회</CustomDialog.Header.Title>
                        <CustomDialog.Header.Close onClick={() => onClose()} />
                    </CustomDialog.Header>
                </StyledHeader>
                <StyledBody>
                    <form onSubmit={(e) => { e.preventDefault(); handleSetSearchQuery(); }}>
                        <StyledSearchCondition>
                            <CustomSelect
                                // value={searchCondition} onChange={(e) => setSearchCondition(e.target.value)}
                                ref={searchConditionRef}
                            >
                                <option value='PRODUCT_NAME_AND_OPTION_NAME'>상품명+옵션명</option>
                                <option value='PRODUCT_OPTION_CODE'>상품코드</option>
                            </CustomSelect>
                            <CutstomRefInput
                                ref={searchQueryRef}
                                type='text'
                                placeholder='상품명+옵션명은 &&로 구분'
                            />
                            <CustomBlockButton
                                type='submit'
                            >
                                <div className='icon-figure'>
                                    <CustomRatioImage>
                                        <CustomRatioImage.Image src='/assets/icons/search_000000.svg' />
                                    </CustomRatioImage>
                                </div>
                            </CustomBlockButton>
                            <CustomBlockButton
                                type='button'
                                onClick={() => handleRefreshSearchCondition()}
                            >
                                <div className='icon-figure'>
                                    <CustomRatioImage>
                                        <CustomRatioImage.Image src='/assets/icons/replay_000000.svg' />
                                    </CustomRatioImage>
                                </div>
                            </CustomBlockButton>
                        </StyledSearchCondition>
                    </form>
                    {(productOptionsStructure && productOptionsStructure?.items?.length > 0) ? (
                        <>
                            <StyledCardList>
                                {productOptionsStructure?.items?.map((item, index) => {
                                    return (
                                        <StyledCard key={index} onClick={() => handleClickCard(item)}>
                                            <div className='name-wrapper'>
                                                <div>{item?.product?.name}</div>
                                                <div>/</div>
                                                <div>{item?.productOption?.name}</div>
                                                {item?.productOption?.packageYn === 'y' &&
                                                    <div><span className={`package`}>패키지</span></div>
                                                }
                                            </div>
                                            <div className='optionCode-wrapper'>
                                                <div>{item?.productOption?.code}</div>
                                            </div>
                                            <div className={`stock-wrapper ${item?.inventoryStock?.stockUnit <= 0 ? 'out-of-stock' : ''}`}>재고수량: {item?.inventoryStock?.stockUnit}</div>
                                        </StyledCard>
                                    )
                                })}
                            </StyledCardList>
                            <StyledPagination>
                                <CustomBlockButton
                                    type='button'
                                    className={`${(!productOptionsStructure?.page || productOptionsStructure?.page <= 1) ? 'disabled' : ''}`}
                                    disabled={(!productOptionsStructure?.page || productOptionsStructure?.page <= 1)}
                                    onClick={() => handlePageToPrev()}
                                >
                                    <div className='icon-figure'>
                                        <CustomRatioImage>
                                            <CustomRatioImage.Image src='/assets/icons/arrowBack_default_000000.svg' />
                                        </CustomRatioImage>
                                    </div>
                                </CustomBlockButton>
                                <div className='page-number'>{productOptionsStructure?.page ?? 0}</div>
                                <CustomBlockButton
                                    type='button'
                                    className={`${!productOptionsStructure?.hasNext ? 'disabled' : ''}`}
                                    disabled={(!productOptionsStructure?.hasNext)}
                                    onClick={() => handlePageToNext()}
                                >
                                    <div className='icon-figure'>
                                        <CustomRatioImage>
                                            <CustomRatioImage.Image src='/assets/icons/arrowForward_default_000000.svg' />
                                        </CustomRatioImage>
                                    </div>
                                </CustomBlockButton>
                            </StyledPagination>
                        </>
                    )
                        :
                        (
                            <>
                                <DialogContent>
                                    <div>검색 결과가 없습니다.</div>
                                </DialogContent>
                            </>
                        )
                    }
                </StyledBody>
            </CustomDialog>
        </>
    );
}